import script from "./edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit.vue?vue&type=script&lang=ts&setup=true"

import "./edit.vue?vue&type=style&index=0&id=479b1ad2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479b1ad2"]])

export default __exports__